export { default as DataTable } from './_DataTableController';